'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './e-form.routes';

export class EFormComponent {
  constructor(EFormsService, Auth, $state, dialogs, $filter, $stateParams, $uibModal, EFormResultsService, $scope) {
    'ngInject';
    this.EFormsService = EFormsService;
    this.EFormResultsService = EFormResultsService;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$scope = $scope;
    this.eFormId = $stateParams.id;
    this.model = {};
    this.$filter = $filter;
    this.$uibModal = $uibModal;

    this.eFormResult = {
      form: this.eFormId,
      data: {}
    };

    this.isLoggedIn = Auth.isLoggedInSync();
    this.user = Auth.getCurrentUserSync();

    if (this.eFormId) {
      this.EFormsService.get({id: this.eFormId}, form => {    //TODO: getPublicByName
        this.schema = form.formSchema;
        this.form = ["*"];
        this.title = form.name;
        this.description = form.description;
        this.recipients = form.recipients;
        this.signatureRequired = form.signatureRequired;

        form.fields.forEach(field => {

          // Check for Recipient Group Field
          if (field.type === 'recipient') {
            this.recipientField = field.key;
          }

          // Prefill
          if (field.prefill && field.prefilled) {

            let [group, value] = field.prefilled.split(":");

            switch (group) {
              case 'name':

                if (this.isLoggedIn && this.user) {

                  switch(value) {
                    case 'first':
                      this.model[field.key] = this.user.firstName || '';
                      break;
                    case 'last':
                      this.model[field.key] = this.user.lastName || '';
                      break;
                    case 'full':
                      if (this.user.firstName && this.user.lastName) {
                        let name = this.user.firstName;
                        if (this.user.middleName)
                          name += " " + this.user.middleName;
                        name += " " + this.user.lastName;

                        this.model[field.key] = name;
                      }
                      break;
                  }
                }

                break;
              case 'profile':

                if (this.isLoggedIn && this.user) {

                  switch(value) {
                    case 'email':
                      this.model[field.key] = this.user.email;
                      break;
                    case 'phone':
                      if (this.user.profile.phone && this.user.profile.phone.length) {
                        this.model[field.key] = this.user.profile.phone[0].number;
                      }
                      break;
                    case 'address':
                      if (this.user.profile.address && this.user.profile.address.length) {
                        let oAdr = [];
                        let adr = this.user.profile.address[0];

                        oAdr.push(adr.street);
                        oAdr.push(", ");
                        if (adr.street2) {
                          oAdr.push(adr.street2);
                          oAdr.push(", ");
                        }
                        oAdr.push(adr.city);
                        oAdr.push(", ");
                        oAdr.push(adr.state);
                        oAdr.push(" ");
                        oAdr.push(adr.zip);
                        if (adr.country) {
                          oAdr.push(", ");
                          oAdr.push(adr.country);
                        }

                        this.model[field.key] = oAdr.join("");
                      }
                      break;
                  }

                }

                break;
              case 'date':
                this.model[field.key] = this.$filter('date')(new Date(), value);
                break;
            }

          }
        });

      }, _ => {
        console.log("Could not load e-form schema from server");
        this.formNotFound = true;
      });
    }
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    const filterRecipients = (recipient, group) => {
      let splitted = recipient.split("|");
      if (splitted.length === 2) {
        if (!group) {
          return true;
        }
        else {
          return splitted[1].trim() === group.trim()
        }
      } else {
        return true;
      }
    };

    const mapRecipients = (recipient) => {
      let splitted = recipient.split("|");

      return (splitted.length === 2) ? splitted[0].trim() : recipient.trim();
    };

    var that = this;

    // First we broadcast an event so all fields validate themselves
    this.$scope.$broadcast('schemaFormValidate');

    if (form.$valid) {
      var onSuccess = (response) => {
        var dlg = this.dialogs.notify("Success", "The form has been sent successfully");

        dlg.result.then(() => {
          that.sendSuccess = true;
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.eFormResult.data = this.model;

      // Filter for recipient group (if this.recipientField is not set, it gets ignored and all recipients will be added)
      this.eFormResult.recipients = this.recipients
        .filter(recipient => filterRecipients(recipient, this.model[this.recipientField]))
        .map(recipient => mapRecipients(recipient));

      if (this.signatureRequired) {

        var that = this;

        var modalInstance = this.$uibModal.open({
          animation: true,
          component: 'signatureModal',
          resolve: {
            config: function(){
              return {
                //instructions: "<p>This e-Form needs to be signed below:</p><hr/>"
              }
            }
          }
        });

        modalInstance.result.then(
          function (signatureImage) {
            that.eFormResult.data.signature = signatureImage;

            let FN_SAVE = that.isLoggedIn ? "save" : "savePublic";

            that.EFormResultsService[FN_SAVE](that.eFormResult, onSuccess, onError);
          },
          function () { /* cancel */ }
        );

      } else {

        let FN_SAVE = that.isLoggedIn ? "save" : "savePublic";

        this.EFormResultsService[FN_SAVE](this.eFormResult, onSuccess, onError);
      }

    }
  }
}

export default angular.module('conduu.eForms.eForm', [uiRouter])
  .config(routes)
  .component('eForm', {
    template: require('./e-form.html'),
    controller: EFormComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/e-form/form/e-form.component.js